import {useEffect} from 'react'

import {Action, sendAULog} from '@financial/common-logs'

import InsuranceConnectBanner from '$components/insurance/common/InsuranceConnectBanner'
import {
    InsuranceDetailFreeCoverage,
    InsuranceDetailFreeInfo,
} from '$components/insurance/my/detail/free/InsuranceDetailFreeInfo'
import InsuranceDetailBottomInfo from '$components/insurance/my/detail/InsuranceDetailBottomInfo'
import useFreeInsuranceDetail from '$hooks/insurance/my/free/useFreeInsuranceDetail'
import {useInsuranceBannerHooks} from '$hooks/useInsuranceBannerHooks'

export default function InsuranceDetailFreeSection() {
    const {hasValidInsurances} = useFreeInsuranceDetail()
    const {getBanner} = useInsuranceBannerHooks({hasValidInsurances})
    const Banner = getBanner(InsuranceConnectBanner)

    useEffect(() => {
        if (hasValidInsurances) {
            sendAULog({page: 'insu', area: 'D', service: 'md', code: 'insu_my_detail_free_registered'}, Action.View)
        } else {
            sendAULog({page: 'insu', area: 'D', service: 'md', code: 'insu_my_detail_free_unregistered'}, Action.View)
        }
    }, [hasValidInsurances])

    return (
        <>
            <InsuranceDetailFreeInfo />
            <Banner
                bannerType={'detail-type'}
                nClickCode="insudetail.frregit"
                auLogParam={{page: 'insu', area: 'D', service: 'md', code: 'insu_my_detail_free_unregistered_connect'}}
            />
            <InsuranceDetailFreeCoverage />
            <InsuranceDetailBottomInfo />
        </>
    )
}
